(function(){
var NAMES = ['Camille R.','Julien M.','Sophie L.','Thomas B.','Marine D.','Yanis K.','Léa P.','Nicolas F.','Chloé V.','Alexandre T.','Inès G.','Maxime R.','Pauline S.','Hugo L.','Amélie C.','Karim B.','Élodie N.','Vincent A.','Sarah M.','Théo D.','Manon J.','Fabien L.','Clara H.','Olivier P.','Nadia Z.','Benoît F.','Laure T.','Samir O.','Anaïs W.','Grégory M.','Solene B.','Damien C.','Audrey V.','Rachid L.','Emma S.','Ludovic P.','Céline A.','Bastien N.','Myriam D.','Antoine G.','Valérie J.','Kevin H.','Sandra E.','Jonathan R.','Lucie B.','Farid T.','Marion K.','Étienne C.','Nathalie P.','Romain V.','Sabrina M.','Guillaume D.','Alice F.','Mehdi S.','Charlotte L.','Patrick B.','Ophelie R.','Quentin T.','Brigitte N.','Adrien M.','Jessica C.','Laurent G.','Maeva P.','Hakim B.','Justine V.','Cedric L.','Aurelie D.','Stephane F.','Noemie T.','Bruno M.','Sonia K.','Arnaud P.','Melanie B.','Raphael C.','Delphine V.'];
var STAR_PATTERNS = {
 '4,9':[5,5,5,5,5,5,5,4,5,5,5,5,5,5,5,5,5,4,5,5,5,5,5,5,5],
 '4,8':[5,5,5,5,4,5,5,5,5,5,5,4,5,5,5,5,5,5,5,4,5,5,5,5,5],
 '4,7':[5,5,5,5,4,5,5,5,4,5,5,5,5,5,4,5,5,5,5,5,4,5,5,5,5],
 '4,6':[5,5,4,5,5,5,4,5,5,5,4,5,5,5,5,4,5,5,5,4,5,5,5,5,5]
};
var MONTHS = ['01','02','03','04','05','06','07','08','09'];

function hash(s){ var h=0; for(var i=0;i<s.length;i++){ h=(h*31+s.charCodeAt(i))>>>0; } return h; }

function dates(seed){
 var out=[], d=new Date(2026,8,10);
 var r=seed;
 for(var i=0;i<25;i++){
  r=(r*1103515245+12345)>>>0;
  var gap=3+(r%9);
  d=new Date(d.getTime()-gap*86400000);
  var dd=('0'+d.getDate()).slice(-2), mm=('0'+(d.getMonth()+1)).slice(-2);
  out.push(dd+'/'+mm+'/'+d.getFullYear());
 }
 return out;
}
function names(seed){
 var out=[], used={}, r=seed;
 for(var i=0;i<25;i++){
  var idx;
  do { r=(r*1103515245+12345)>>>0; idx=r%NAMES.length; } while(used[idx]);
  used[idx]=1; out.push(NAMES[idx]);
 }
 return out;
}

window.lpcReviews = function(handle){
 var src = (window.LPC_RV||{})[handle];
 if(!src) return null;
 var seed = hash(handle)||7;
 var nm = names(seed), dt = dates(seed);
 var st = STAR_PATTERNS[src.n] || STAR_PATTERNS['4,8'];
 var items = [];
 for(var i=0;i<src.t.length;i++){
  items.push({name:nm[i], date:dt[i], stars:st[i%st.length], text:src.t[i]});
 }
 return {rating:src.n, count:src.c, items:items};
};

function syncHeader(d){
 var els = document.querySelectorAll('span, div, p');
 var re = /\/5\s*·\s*\d+\s*avis/;
 for(var i=0;i<els.length;i++){
  var el = els[i];
  if(el.children.length > 2) continue;
  var txt = el.textContent || '';
  if(!re.test(txt)) continue;
  if(txt.replace(/\s/g,'').length > 24) continue;
  var strong = el.querySelector('strong');
  if(strong){
   strong.textContent = d.rating;
   var after = strong.nextSibling;
   if(after && after.nodeType === 3) after.nodeValue = '/5 · ' + d.count + ' avis';
  } else {
   el.textContent = d.rating + '/5 · ' + d.count + ' avis';
  }
  break;
 }
}

window.lpcRenderReviews = function(root){
 var handle = root.getAttribute('data-handle');
 var d = window.lpcReviews(handle);
 if(!d){ root.style.display='none'; return; }
 var track = root.querySelector('[data-rv-track]');
 var rt = root.querySelector('[data-rv-rating]');
 var ct = root.querySelector('[data-rv-count]');
 if(rt) rt.textContent = d.rating;
 if(ct) ct.textContent = 'sur ' + d.count + ' avis';
 track.innerHTML = d.items.map(function(r){
  var s='';
  for(var i=0;i<5;i++) s += i<r.stars ? '\u2605' : '\u2606';
  return '<div style="flex:0 0 320px;scroll-snap-align:start;background:#fff;border:1px solid #ECE9DC;border-radius:16px;padding:22px 24px;display:flex;flex-direction:column">'
   +'<span style="color:#C9A961;font-size:13px;letter-spacing:2px">'+s+'</span>'
   +'<p style="font-size:14.5px;line-height:1.6;color:#3C4A3C;margin:12px 0 14px;font-style:italic;flex:1">\u00ab '+r.text+' \u00bb</p>'
   +'<div style="font-size:13px;color:#8A938A"><strong style="color:#1A1A1A">'+r.name+'</strong> \u00b7 '+r.date+' \u00b7 Achat vérifié \u2713</div></div>';
 }).join('');
 syncHeader(d);
};

window.lpcRvScroll = function(btn,dir){
 var track = btn.closest('[data-rv-root]').querySelector('[data-rv-track]');
 track.scrollBy({left: dir*344, behavior:'smooth'});
};

function init(){
 var roots = document.querySelectorAll('[data-rv-root]');
 for(var i=0;i<roots.length;i++) window.lpcRenderReviews(roots[i]);
}
if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
